import request from "./request";
import apis from "./apis";

const {
  allDocumentInfo,
  createDocument,
  updateDocument,
  deleteDocument,
  downloadDocument,
} = apis.document;

const document = {
  getAllDocument: () => {
    return request.get(allDocumentInfo);
  },
  createDocument: (data: Object) => {
    return request.formJsonPost(createDocument, data);
  },
  updateDocument: (data: Object) => {
    return request.put(updateDocument, data);
  },
  deleteDocument: (id: string) => {
    return request.idDelete(deleteDocument, id);
  },
  downloalDocument: (id: string) => {
    return request.idGetBlob(downloadDocument, id);
  },
};

export default document;